import {
  isAdminOrControllerUser,
  isAdminUser,
  isControllerUser,
  isCustomerOrManagerUser,
  isCustomerUser,
  isCustomerUserMe,
  isCustomerUserRole,
  isManufacturerUser,
  isManufacturerUserRole,
  isRoleControllerOrHigher,
  isRoleHigher,
  isRoleNightAgentOrHigher,
} from "./role-checker";

export const RoleChecker = {
  isAdminUser,
  isControllerUser,
  isCustomerUser,
  isCustomerUserMe,
  isRoleHigher,
  isRoleNightAgentOrHigher,
  isRoleControllerOrHigher,
  isCustomerOrManagerUser,
  isAdminOrControllerUser,
  isCustomerUserRole,
  isManufacturerUser,
  isManufacturerUserRole,
};
